// extracted by mini-css-extract-plugin
export default {"competencies":"Competencies-module__competencies__UfZI2","categories":"Competencies-module__categories__rFRz3","aside":"Competencies-module__aside__mIyp-"};